import CrudService from "@/services/shared/http/CrudService"

export default class LocationService extends CrudService {
    constructor(params= {}) {
        super('locations', params)
    }
}
